import React, { Component } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import loading from '../assets/img/beautrium/loading_beautrium.svg';

class Loading extends Component {
    render() {
        return (
            <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", display: "flex", backgroundColor: "rgba(255, 255, 255, 0.7)", zIndex: 9999 }}>
                <div className="loading-icon" style={{ transform: "translate(-50%, -50%)", position: "fixed", top: "50%", left: "50%" }}><img style={{ width: "100px", height: "auto", animation: "multiply 4s infinite ease-in-out" }} src="https://cdn.thebeautrium.com/web-image/plus.svg" alt="BEAUTRIUM Loading" /></div>
                {/* <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 1200.1 1200" xmlSpace="preserve">
                    <g>
                        <path fill="none" stroke="#C10017" strokeWidth="100" strokeMiterlimit="10" className="path" d="M775.3,433.2l35.3,1c86.1,2.5,166.4,36.8,226.3,96.7c62.6,62.6,97.1,145.8,97.1,234.4
                        c0,182.8-148.7,331.5-331.5,331.5H111.3V405.6c0-182.8,148.7-331.5,331.6-331.5c178.4,0,326.9,145.1,331.2,323.5l0.8,35.1l0,0.5
                        l-8.4,35.3c-29.8,134.7-88.5,228-157.2,249.5c-33.7,10.7-67.2,2.1-94.4-25c-26.7-26.6-35.5-60.1-24.9-94.3
                        C512,528.7,603,471.4,739.6,441.4l35.3-8.3L775.3,433.2z"/>
                    </g>
                </svg> */}
            </div>
        );
    }
}

export default Loading;